import { filesService } from '../../utils/services/files.service';

export default class UploadAdapter {
    constructor(loader) {
        // The file loader instance to use during the upload.
        this.loader = loader;
        this.base64 = '';
    }

    // Starts the upload process.
    upload() {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.addEventListener('load', (file) => {
                this.base64 = file.target.result;
                resolve({ default: reader.result });
            });

            reader.addEventListener('error', err => {
                reject(err);
            });

            reader.addEventListener('abort', () => {
                reject();
            });

            this.loader.file.then(file => {
                filesService.upload({
                    file: { ...file, ...{ base64: this.base64 } },
                });
                reader.readAsDataURL(file);
            });
        });
    }

    // Aborts the upload process.
    abort() {
         //
    }
}

export const uploader = function (editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => new UploadAdapter(loader);
};
